module.exports = __webpack_public_path__ + "public/media/marketeer-right.png";


//////////////////
// WEBPACK FOOTER
// ./images/services/marketeer-right.png
// module id = ./images/services/marketeer-right.png
// module chunks = 0